module.exports = __webpack_public_path__ + "static/media/profile__avatar.ee36e64c.svg";